<div class="wrapper">
  <label
    class="input-wrapper"
    [for]="id"
    [class.readonly]="readonly"
    [class.invalid]="showError"
    [class.invalid-border]="showError && forceErrorDisplay"
    [class.focused]="focused"
    [class.viewonly]="viewOnly"
    (mousedown)="readonly ? onFocus.emit() : undefined"
  >
    <div class="icon">
      <ng-content select="[icon]"></ng-content>
    </div>
    <input
      #input
      [id]="id"
      [placeholder]="this.label || ''"
      [class.readonly]="readonly"
      [attr.readonly]="readonly ? true : null"
      [disabled]="isDisabled || readonly ? true : null"
      [ngModel]="
        readonly ? (value | caiNumberFormatter: true : decimalPlace) : value
      "
      (ngModelChange)="value = $event"
      (focus)="onFocus.emit()"
      (focusin)="focused = true"
      (focusout)="focused = false"
      (keypress)="onKeyPress($event)"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      (paste)="onPaste($event)"
      (blur)="onBlur()"
      autocomplete="off"
    />
    @if (!readonly) {
      <button
        class="viewonly-data"
        [id]="id"
        [class.filled]="value"
        (focus)="onFocus.emit(); input.focus()"
      >
        {{
          value
            ? (value | caiNumberFormatter: true : decimalPlace)
            : placeholder
        }}
      </button>
    }
    @if (unit && !showUnitSelector) {
      <span class="unit">{{ unit }}</span>
    }
    @if (showUnitSelector) {
      <cai-load-type-unit-selector
        (click)="$event.preventDefault()"
        [(selected)]="selectedUnit"
        [isParentMetric]="
          weightUnit?.code
            ? matchMeasurementSystem(measurementSystemEnum.METRIC)
            : undefined
        "
        [isParentImperial]="
          weightUnit?.code
            ? matchMeasurementSystem(measurementSystemEnum.IMPERIAL)
            : undefined
        "
        (selectedChange)="selectedUnitChange.emit($event)"
        [(measurementSystem)]="measurementSystem"
        (measurementSystemChange)="measurementSystemChange.emit($event)"
        [options]="measurementUnits"
        [marginTop]="10"
      ></cai-load-type-unit-selector>
    }
    @if (!viewOnly) {
      <label
        class="input-label"
        [class.tr]="isTurkish"
        [class.always-float]="readonly"
        [class.chargeableWeightLabel]="!readonly && id === 'chargeable-weight'"
        >{{ label }}</label
      >
    }
  </label>
</div>
